<div class="row">
  <div class="col-md-4">
    <div class="row">
      <div class="col"><img [src]="logoService.logoSource"></div>
    </div>
    <div class="row">
      <div class="col"><h1>{{ appConfig.umgebung }}</h1></div>
    </div>

    <div class="row">
      <div class="col-md" *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Langfristiger Aufenthalt</div>
      <div class="col-md" *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n>Kurzfristiger Aufenthalt</div>
    </div>

    <div class="row mt-4">
      <div class="col-md-auto pb-3">
        <select class="form-select form-select-sm" style="width: auto;"
                (change)="switchLanguage()"
                [(ngModel)]="selectedLanguage"
                *ngIf="appConfig.umgebung === 'VIDEX'">
          <option value="de">Deutsch</option>
          <option value="en">English</option>
          <option value="ar">العربية</option>
          <option value="zh">中文</option>
          <option value="fr">français</option>
          <option value="id">bahasa Indonesia</option>
          <option value="fa">فارسی</option>
          <option value="pt">português</option>
          <option value="ru">русский</option>
          <option value="es">español</option>
          <option value="tr">Türkçe</option>
          <option value="vi">Tiếng Việt</option>
        </select>
      </div>
    </div>
  </div>
  <div class="col-md-8">
    <div class="row">
      <div class="col" *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"><img src="assets/headerbild_videx_c_small.jpg"
                                                                                                 width="100%" height="100%"
                                                                                                 title="&copy; colourbox.com"></div>
      <div class="col" *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"><img src="assets/headerbild_videx_small.jpg" width="100%"
                                                                                                 height="100%"></div>
    </div>
    <div class="row mt-3">
      <div class="col d-md-flex justify-content-md-start">
        <div>
          <button type="button" (click)="onNeuerAntragClicked()" class="btn btn-primary mb-1" style="width: 100%; background-color: #367297">
            <i class="icon-new" style="font-size: 20px; vertical-align: text-bottom"></i> <span i18n>Neuer Antrag</span>
          </button>
        </div>
        <div class="ms-md-3">
          <button type="button" (click)="onScanBarcode()" class="btn btn-primary mb-1" style="width: 100%; background-color: #367297">
            <i class="icon-barcode" style="font-size: 20px; vertical-align: text-bottom"></i> <span i18n>Barcode scannen</span>
          </button>
        </div>
        <div *ngIf="appConfig.isImportActive" class="ms-md-3">
          <button type="button" (click)="onLoadFile()" class="btn btn-primary mb-1" style="width: 100%; background-color: #367297">
            <i class="icon-upload" style="font-size: 20px; vertical-align: text-bottom"></i> <span i18n>Daten importieren</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #neuerAntrag let-c="close">
  <div class="modal-header">
    <h4 class="modal-title" i18n>Eingegebene Daten verwerfen?</h4>
    <button type="button" class="modal-close" aria-label="Close" (click)="c('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p style="font-weight: bold" i18n>Wollen Sie wirklich die eingegebenen Daten verwerfen?</p>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="c('cancel')" class="btn btn-danger" style="width: 170px"><span i18n>Abbrechen</span></button>
    <button type="button" (click)="c('ok')" class="btn btn-primary" style="width: 170px; background-color: #367297"><span i18n>OK</span></button>
  </div>
</ng-template>

<ng-template #scanBarcode let-c="close">
  <div class="modal-header">
    <h4 class="modal-title" i18n>Barcode scannen</h4>
    <button type="button" class="modal-close" aria-label="Close" (click)="c('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p style="font-weight: bold" i18n>Geben Sie den Barcode ein und klicken Sie auf "Senden".</p>
    <input id="barcodeField" class="w-100" appAutofocus #barcodeField>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="c('cancel')" style="width: 170px" class="btn btn-danger"><span i18n>Abbrechen</span></button>
    <button type="button" class="btn btn-primary" style="width: 170px; background-color: #367297" (click)="barcode=barcodeField.value; c('ok'); ">
      <span i18n>Senden</span></button>
  </div>
</ng-template>

<ng-template #loadFile let-c="close">
  <div class="modal-header">
    <h4 class="modal-title" i18n>Daten importieren</h4>
    <button type="button" class="modal-close" aria-label="Close" (click)="c({ result: 'cancel' })">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p style="font-weight: bold;" class="mx-1" i18n>Wählen Sie die JSON-Datei zum Importieren aus.</p>
    <div class="input-group mx-1">
      <input type="text" class="form-control col-sm-8" disabled #filename>
      <label for="loadFileInput" class="form-label col-sm-4 mb-0 btn btn-primary" i18n>Datei auswählen...</label>
    </div>
    <input type="file" id="loadFileInput" class="form-control-file" style="opacity:0; position:absolute; top:0; left:0"
           (change)="filename.value=(fileinput.files[0]) ? fileinput.files[0].name : ''"
           #fileinput/><br/>

    <p
      *ngIf="hasFileLoadError"
      style="font-weight: bold; color:#ca7d7d"
      i18n
    >Keine gültige Datei!</p>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="c({ result: 'cancel' })" class="btn btn-danger" style="width: 170px;">
      <span i18n>Abbrechen</span></button>
    <button type="button" style="width: 170px; background-color: #367297"
            class="btn btn-primary"
            (click)="c({ result: 'ok', payload: fileinput.files })"
    >
      <span i18n>Daten importieren</span>
    </button>
  </div>
</ng-template>
